<template>
    <div>
        <div>
<!--            <div v-for="(item,index) in showinList" style="display: inline-block;padding: 5px 10px;border: 1px solid #8e8e8e;margin-right: 15px">-->
<!--                {{item.vc_pname+'-'+item.vc_name}}-->
<!--                    <i class="el-icon-close" style="color: red;margin-left: 5px" @click="deleteFun(item,index)"></i>-->
<!--            </div>-->
            <el-table class="mrt10"  ref="choosetable"　size="mini" :height="tableHeight" border :data="showinList" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
<!--                <el-table-column  align="center"  :reserve-selection="true" type="selection" width="50px"></el-table-column>-->
                <!--         @select="selectFun" @select-all="selectAllFun"           -->
                 <el-table-column :label="$t('form_serial_number')" align="center" type="index" width="50px"></el-table-column>
<!--                <el-table-column align="center" label="产品分类ID" prop="i_pztypeid" show-overflow-tooltip></el-table-column>-->
                <el-table-column align="center" label="产品ID" prop="i_id" width="80px" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="上级产品分类" prop="vc_pname" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="末级产品分类" prop="vc_name" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="是否直属" prop="vc_name" show-overflow-tooltip v-if="data.type=='zycp'">
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.isMainType" :true-label="1" :false-label="0" :disabled="showinList.findIndex(x=>x.isMainType==1)!=-1&&scope.row.isMainType!=1">直属</el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80"  align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="deleteFun(scope.row,scope.$index)" icon="el-icon-close" style="color: red;padding:0"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-input style="width: 220px" class="marr4" clearable size="mini" placeholder="产品分类名称" v-model="cpvc_name">
            </el-input>        <el-button class="marB10" icon="el-icon-search" circle @click="searchcpFun " size="mini" ></el-button>
            <el-table class="mrt10" row-key="i_id" @selection-change="handleSelectionChange"  ref="table"　size="mini" :height="tableHeight" border :data="cptableData" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
                <el-table-column  align="center"  :reserve-selection="true" type="selection" width="50px"></el-table-column>
                <!--         @select="selectFun" @select-all="selectAllFun"            <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column>-->
<!--                <el-table-column align="center" label="产品分类ID" prop="i_pztypeid" show-overflow-tooltip></el-table-column>-->
                <el-table-column align="center" label="产品ID" prop="i_id" width="80px" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="上级产品分类" prop="vc_pname" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="末级产品分类" prop="vc_name" show-overflow-tooltip></el-table-column>
<!--                <el-table-column align="center" label="产品名" prop="vc_name" show-overflow-tooltip>-->
<!--                    <template slot-scope="scope">-->
<!--                        <div>{{scope.row.vc_name+'-'+scope.row.vc_pname}}</div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
            </el-table>
            <el-pagination  style="margin-top: 10px;text-align: right"
                            background
                            @current-change="cppageCurrentChange"
                            layout="total,prev, pager, next"
                            :current-page.sync="cpcurrentPage"
                            :total="cptotal"
                            :page-size="cppageSize">
            </el-pagination>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="mini" >{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "TransferCp",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                tableHeight:0,
                baseerp:'',
                showinList:[],
                inList:[],
                ysinList:[],
                cptableData:[],
                cpcurrentPage: 1,
                cppageSize: 20,
                cptotal:0,
                ggtotal:0,
                cpvc_name:'',
                selectedList:[],
                deleteList:[],
                disabled:false,
            }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            //console.log(this.data,'data')
            this.baseerp=baseerp;
            this.getLastProductType(this.data.pzidList);
            if(this.data.type=='zycp'){
                this.getProductRelated()
            }
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= (n.h-(n.h)*0.3-70)/2;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            deleteFun(val,i){
                this.$refs.table.toggleRowSelection(this.cptableData.find(item=>item.i_id==val.i_id),false)
                this.showinList=this.showinList.filter(item=>item.i_id!==val.i_id)
                this.selectedList=this.selectedList.filter(item=>item.i_id!==val.i_id);
                if(this.ysinList.filter(item=>item.i_id==val.i_id).length&&this.deleteList.filter(item=>item.i_id==val.i_id).length==0){
                    let d=val;
                    d.i_state=-1;
                    this.deleteList.push(d);
                    this.inList=this.inList.filter(item=>item.i_id!==val.i_id);
                }
                // this.showinList=[...this.inList,...this.selectedList];

            },
            handleSelectionChange(val) {
                const  added=[...val].filter(item=>[...this.selectedList].every(y=>y.i_id!=item.i_id));
                const  removeed=[...this.selectedList].filter(item=>[...val].every(y=>y.i_id!=item.i_id));

                // console.log(added,'add',removeed)
                if(val.length>this.selectedList.length){
                    let val=added;
                    val[0].i_state=1
                    // console.log('a++++')
                    this.showinList.push(...added)
                }else{
                    this.showinList=this.showinList.filter(item=>item.i_id!==removeed[0].i_id)
                }
                this.selectedList=[];
                this.selectedList=val;
                // console.log(this.showinList,'this.showinList')
                // this.showinList=[...this.inList,...this.selectedList];
            },
            async getLastProductType(id){
                let param = {
                    currentPage:this.cpcurrentPage,
                    pageSize:this.cppageSize,
                    vc_name:this.cpvc_name,
                    pzidList:id,
                };
                let res = await API.getLastProductType(param);
                if (res.code == 1) {
                    this.cptableData=res.typeList;
                    this.cptotal=res.total;
                    this.cptableData.forEach(item=>{
                        this.ysinList.forEach(y=>{
                            if( y.i_id==item.i_id){
                                this.$refs.table.toggleRowSelection(row,true)
                            }
                           })
                    })
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            searchcpFun(){
                this.cpcurrentPage=1;
                //调用列表接口
                this.getLastProductType(this.data.pzidList);
            },
            cppageCurrentChange(val){
                // console.log(val,"pageval");
                this.cpcurrentPage=val;
                //调用列表接口
                this.getLastProductType(this.data.pzidList);
            },
            cancel(){
                this.$emit('close',null)
            },
            saveForm(){
                if(this.data.type=='zycp'&&this.showinList.length>0&&this.showinList.findIndex(x=>x.isMainType==1)==-1){
                    this.$message.warning('请选择直属产品')

                }else{
                    let list=[...this.showinList,...this.deleteList];
                    list=list.filter(x=>x.i_state==1||x.i_state==-1)
                    list.map(x=>{
                        x.i_typeid=x.i_id
                        x.i_flag=x.i_flag
                        x.i_gsid=x.i_gsid
                        x.i_gid=x.i_gid
                        x.i_order=x.rowNum
                        x.isMainType=x.isMainType?x.isMainType:0
                        x.i_uid=sessionStorage.getItem("userid");
                        x.vc_uname=sessionStorage.getItem("lruname");
                    })

                    this.editPzTypeContent(list)
                    this.disabled=true;
                }
            },

            async editPzTypeContent(list) {
                let param={
                    //i_pzid:this.data.i_id,
                    pzlist:this.data.pzidList,
                    typeList:list
                };
                let res = await API.editPzTypeContent(param);
                if (res.code == 1) {
                    this.$emit('close','save');
                    this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disabled=false;
                    this.$message.error(res.message);
                };
            },
            async getProductRelated() {
                let param={
                    i_id:this.data.i_id,
                    i_pzid:this.data.i_id,
                };
                let res = await API.getProductRelated(param);
                if (res.code == 1) {
                    this.ysinList=res.data.relatedTypeList;
                    this.ysinList.map(ys=>{
                        ys.i_state=1
                    })
                    this.inList=JSON.parse(JSON.stringify(this.ysinList));
                    this.showinList=JSON.parse(JSON.stringify(this.ysinList));
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },

        },
    }
</script>

<style lang="scss" scoped>

</style>